module.exports = __webpack_public_path__ + "static/media/cable-tv.8fda1f5c.png";